import { TGlobalState } from 'reducers';

type ContactFormState = {
  loading: boolean;
  last_action: 'contact_error' | 'contact_success' | null;
};

export const getContactForm = (state: TGlobalState): ContactFormState =>
  state.contactForm;
